module.exports = __webpack_public_path__ + "img/image114.b1e75c88.png";